import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './Payout.css';
import Layout from '../Layout/Layout';

const mockAuthors = [
  { author: 'John Doe', articles: 15, payoutRate: 10 },
  { author: 'Jane Smith', articles: 20, payoutRate: 12 },
  { author: 'Alex Brown', articles: 10, payoutRate: 8 },
];

const PayoutPage = () => {
  const isAdmin = useSelector(state => state.auth.isAdmin);
  const [payouts, setPayouts] = useState(mockAuthors);

  const handleRateChange = (author, value) => {
    setPayouts(prev =>
      prev.map(p => p.author === author ? { ...p, payoutRate: value } : p)
    );
  };

  if (!isAdmin) {
    return <Layout><div className="access-denied">🚫 Access Denied: Admin Only</div></Layout>;
  }

  return (
    <Layout>
        <div className="payout-wrapper">
        <h2 className="payout-title">💰 Author Payout Calculator</h2>
        <table className="payout-table">
            <thead>
            <tr>
                <th>Author</th>
                <th>Articles</th>
                <th>Payout Rate ($)</th>
                <th>Total Payout ($)</th>
            </tr>
            </thead>
            <tbody>
            {payouts.map((payout, idx) => (
                <tr key={idx}>
                <td>{payout.author}</td>
                <td>{payout.articles}</td>
                <td>
                    <input
                    type="number"
                    value={payout.payoutRate}
                    onChange={(e) => handleRateChange(payout.author, parseFloat(e.target.value))}
                    />
                </td>
                <td>${payout.articles * payout.payoutRate}</td>
                </tr>
            ))}
            </tbody>
        </table>
        </div>
    </Layout>
  );
};

export default PayoutPage;
